// src/data/store.js
// Central mock data store - replace with API calls in production

export const ROLES = {
  ADMIN: 'admin',
  ENCODER: 'encoder',
  DISPATCHER: 'dispatcher',
  CLIENT: 'client',
};

export const ROLE_LABELS = {
  admin: 'Administrator',
  encoder: 'Encoder',
  dispatcher: 'Dispatcher',
  client: 'Client',
};

export const ROLE_COLORS = {
  admin: '#f97316',
  encoder: '#3b82f6',
  dispatcher: '#8b5cf6',
  client: '#10b981',
};

export const MODULE_LIST = [
  { id: 'dashboard', label: 'Dashboard', roles: ['admin', 'encoder', 'dispatcher'] },
  { id: 'users', label: 'User Management', roles: ['admin'] },
  { id: 'clients', label: 'Client Management', roles: ['admin'] },
  { id: 'trucks', label: 'Truck Management', roles: ['admin', 'encoder', 'dispatcher'] },
  { id: 'gps', label: 'GPS Devices', roles: ['admin', 'encoder'] },
  { id: 'gpsLoads', label: 'SIM Load Monitor', roles: ['admin', 'encoder'] },
  { id: 'documents', label: 'Documents', roles: ['admin', 'encoder', 'dispatcher'] },
  { id: 'tracking', label: 'Live Tracking', roles: ['admin', 'dispatcher'] },
  { id: 'geofencing', label: 'Geofencing', roles: ['admin', 'dispatcher'] },
  { id: 'history', label: 'Travel History', roles: ['admin', 'dispatcher'] },
  { id: 'reports', label: 'Reports', roles: ['admin', 'dispatcher'] },
  { id: 'settings', label: 'Settings', roles: ['admin'] },
];

// Default settings
export const DEFAULT_SETTINGS = {
  idleNotificationEnabled: true,
  idleThresholdMinutes: 5,
  idleNotificationRepeatMinutes: 10,
  idlePopupDurationSeconds: 8,
  companyName: 'ShipDoTrack',
  timezone: 'Asia/Manila',
  documentTypes: ['Delivery Receipt', 'Waybill', 'Bill of Lading', 'Cargo Manifest', 'Trip Ticket', 'Gate Pass'],
};

// Default modules per role
export const DEFAULT_MODULES = {
  admin: ['dashboard', 'users', 'clients', 'trucks', 'gps', 'gpsLoads', 'documents', 'tracking', 'geofencing', 'history', 'reports', 'settings'],
  encoder: ['dashboard', 'trucks', 'gps', 'gpsLoads', 'documents'],
  dispatcher: ['dashboard', 'trucks', 'documents', 'tracking', 'geofencing', 'history', 'reports'],
  client: ['my_trucks', 'live_map'],
};

export const initialUsers = [
  {
    id: 'u1',
    name: 'Maria Santos',
    email: 'admin@shipdotrack.com',
    password: 'admin123',
    role: ROLES.ADMIN,
    avatar: 'MS',
    modules: DEFAULT_MODULES.admin,
    status: 'active',
    createdAt: '2024-01-10',
    phone: '+63 912 345 6789',
    clientId: null,
  },
  {
    id: 'u2',
    name: 'Jose Reyes',
    email: 'encoder@shipdotrack.com',
    password: 'encoder123',
    role: ROLES.ENCODER,
    avatar: 'JR',
    modules: DEFAULT_MODULES.encoder,
    status: 'active',
    createdAt: '2024-02-15',
    phone: '+63 917 234 5678',
    clientId: null,
  },
  {
    id: 'u3',
    name: 'Ana Cruz',
    email: 'dispatcher@shipdotrack.com',
    password: 'dispatcher123',
    role: ROLES.DISPATCHER,
    avatar: 'AC',
    modules: DEFAULT_MODULES.dispatcher,
    status: 'active',
    createdAt: '2024-03-01',
    phone: '+63 918 345 6780',
    clientId: null,
  },
  {
    id: 'u4',
    name: 'Pacific Cargo Inc.',
    email: 'client@shipdotrack.com',
    password: 'client123',
    role: ROLES.CLIENT,
    avatar: 'PC',
    modules: ['my_trucks', 'live_map'],
    status: 'active',
    createdAt: '2024-03-15',
    phone: '+63 920 456 7891',
    clientId: 'c1',
  },
];

export const initialClients = [
  {
    id: 'c1',
    name: 'Pacific Cargo Inc.',
    contact: 'Roberto Lim',
    email: 'roberto@pacificcargo.com',
    phone: '+63 920 456 7891',
    address: 'Port Area, Manila',
    status: 'active',
    truckIds: ['t1', 't2'],
    userId: 'u4',
    createdAt: '2024-03-15',
  },
  {
    id: 'c2',
    name: 'Northern Logistics Co.',
    contact: 'Sandra Tan',
    email: 'sandra@northlog.com',
    phone: '+63 915 567 8902',
    address: 'Balintawak, Quezon City',
    status: 'active',
    truckIds: ['t3'],
    userId: null,
    createdAt: '2024-04-01',
  },
];

export const initialGPSDevices = [
  { id: 'g1', deviceId: 'GPS-001', model: 'Teltonika FMB920', simCard: '09171234567', status: 'assigned', assignedTruck: 't1', lastPing: '2024-06-04 10:23', firmware: 'v03.27.07', imei: '', traccarDeviceId: null },
  { id: 'g2', deviceId: 'GPS-002', model: 'Teltonika FMB920', simCard: '09172345678', status: 'assigned', assignedTruck: 't2', lastPing: '2024-06-04 10:21', firmware: 'v03.27.07', imei: '', traccarDeviceId: null },
  { id: 'g3', deviceId: 'GPS-003', model: 'Concox GT06N', simCard: '09173456789', status: 'assigned', assignedTruck: 't3', lastPing: '2024-06-04 10:18', firmware: 'v2.1', imei: '', traccarDeviceId: null },
  { id: 'g4', deviceId: 'GPS-004', model: 'Queclink GV300', simCard: '09174567890', status: 'available', assignedTruck: null, lastPing: '2024-06-01 08:00', firmware: 'v5.2', imei: '', traccarDeviceId: null },
  { id: 'g5', deviceId: 'GPS-005', model: 'Teltonika FMB140', simCard: '09175678901', status: 'maintenance', assignedTruck: null, lastPing: '2024-05-28 14:30', firmware: 'v03.25.01', imei: '', traccarDeviceId: null },
];

export const initialTrucks = [
  {
    id: 't1',
    plateNumber: 'ABC 1234',
    model: 'Isuzu Elf',
    year: '2022',
    type: 'Light Duty',
    capacity: '3.5 tons',
    clientId: 'c1',
    gpsDeviceId: 'g1',
    driver: 'Juan dela Cruz',
    driverPhone: '+63 912 111 2222',
    status: 'moving',
    fuelLevel: 72,
    mileage: '45,230 km',
    lastService: '2024-05-10',
    documents: ['dr1', 'dr2'],
    color: '#3b82f6',
    location: { lat: 14.5995, lng: 120.9842, speed: 45, heading: 'NE', address: 'Roxas Blvd, Manila' },
  },
  {
    id: 't2',
    plateNumber: 'XYZ 5678',
    model: 'Hino 300',
    year: '2021',
    type: 'Medium Duty',
    capacity: '7 tons',
    clientId: 'c1',
    gpsDeviceId: 'g2',
    driver: 'Pedro Santos',
    driverPhone: '+63 913 222 3333',
    status: 'idle',
    fuelLevel: 45,
    mileage: '78,120 km',
    lastService: '2024-04-22',
    documents: ['dr3'],
    color: '#10b981',
    location: { lat: 14.6090, lng: 121.0080, speed: 0, heading: 'N', address: 'Quezon Avenue, QC' },
  },
  {
    id: 't3',
    plateNumber: 'MNO 9012',
    model: 'Mitsubishi Fuso',
    year: '2023',
    type: 'Heavy Duty',
    capacity: '15 tons',
    clientId: 'c2',
    gpsDeviceId: 'g3',
    driver: 'Carlos Ramos',
    driverPhone: '+63 914 333 4444',
    status: 'moving',
    fuelLevel: 88,
    mileage: '12,450 km',
    lastService: '2024-05-30',
    documents: [],
    color: '#f97316',
    location: { lat: 14.5547, lng: 121.0244, speed: 62, heading: 'SE', address: 'C5 Road, Taguig' },
  },
  {
    id: 't4',
    plateNumber: 'DEF 3456',
    model: 'Isuzu NMR',
    year: '2020',
    type: 'Light Duty',
    capacity: '2 tons',
    clientId: null,
    gpsDeviceId: null,
    driver: 'Unassigned',
    driverPhone: '',
    status: 'maintenance',
    fuelLevel: 20,
    mileage: '120,800 km',
    lastService: '2024-03-15',
    documents: [],
    color: '#6b7280',
    location: { lat: 14.5764, lng: 121.0009, speed: 0, heading: 'S', address: 'EDSA, Makati' },
  },
];

export const initialDocuments = [
  { id: 'dr1', truckId: 't1', type: 'Delivery Receipt', docNumber: 'DR-2024-0001', origin: 'Manila Port', destination: 'Laguna Warehouse', date: '2024-06-03', status: 'in-transit', encodedBy: 'u2', cargo: 'Electronic Components', weight: '2.1 tons' },
  { id: 'dr2', truckId: 't1', type: 'Waybill', docNumber: 'WB-2024-0045', origin: 'Makati Office', destination: 'Cebu Hub', date: '2024-06-01', status: 'delivered', encodedBy: 'u2', cargo: 'Office Supplies', weight: '0.8 tons' },
  { id: 'dr3', truckId: 't2', type: 'Delivery Receipt', docNumber: 'DR-2024-0002', origin: 'Quezon City Depot', destination: 'Pampanga Branch', date: '2024-06-04', status: 'pending', encodedBy: 'u2', cargo: 'Construction Materials', weight: '5.5 tons' },
];

export const TRUCK_STATUSES = {
  moving: { label: 'Moving', color: '#10b981', bg: 'rgba(16,185,129,0.12)' },
  idle: { label: 'Idle', color: '#f59e0b', bg: 'rgba(245,158,11,0.12)' },
  maintenance: { label: 'Maintenance', color: '#ef4444', bg: 'rgba(239,68,68,0.12)' },
  offline: { label: 'Offline', color: '#6b7280', bg: 'rgba(107,114,128,0.12)' },
};

// ── Travel History (demo seed data) ────────────────────────────────────────────
// Generates a realistic sequence of idle-stop and moving events for demo trucks
function makeHistory(truckId) {
  const routes = {
    t1: [
      { lat: 14.5995, lng: 120.9842, address: 'Roxas Blvd, Manila' },
      { lat: 14.5764, lng: 121.0009, address: 'EDSA, Makati' },
      { lat: 14.5547, lng: 121.0244, address: 'C5 Road, Taguig' },
      { lat: 14.5200, lng: 121.0500, address: 'Alabang, Muntinlupa' },
      { lat: 14.4795, lng: 120.9800, address: 'Bacoor, Cavite' },
    ],
    t2: [
      { lat: 14.6090, lng: 121.0080, address: 'Quezon Avenue, QC' },
      { lat: 14.6300, lng: 121.0300, address: 'Commonwealth Ave, QC' },
      { lat: 14.6700, lng: 121.0600, address: 'Batasan Hills, QC' },
      { lat: 14.7000, lng: 121.1000, address: 'Antipolo, Rizal' },
    ],
    t3: [
      { lat: 14.5547, lng: 121.0244, address: 'C5 Road, Taguig' },
      { lat: 14.5800, lng: 121.0600, address: 'Ortigas, Pasig' },
      { lat: 14.6090, lng: 121.0400, address: 'Cubao, QC' },
    ],
  };
  const locs = routes[truckId] || routes.t1;
  const history = [];
  const now = Date.now();
  let time = now - (8 * 60 * 60 * 1000); // start 8 hours ago

  locs.forEach((loc, i) => {
    // Idle stop event
    history.push({
      id: `${truckId}_h${i}_idle`,
      truckId,
      type: 'idle',
      lat: loc.lat,
      lng: loc.lng,
      address: loc.address,
      speed: 0,
      timestamp: new Date(time).toISOString(),
      duration: Math.floor(8 + Math.random() * 25),
    });
    time += Math.floor((8 + Math.random() * 25) * 60 * 1000);

    // Moving segment (except after last stop)
    if (i < locs.length - 1) {
      history.push({
        id: `${truckId}_h${i}_move`,
        truckId,
        type: 'moving',
        lat: loc.lat + (Math.random() - 0.5) * 0.01,
        lng: loc.lng + (Math.random() - 0.5) * 0.01,
        address: `En route to ${locs[i + 1].address}`,
        speed: Math.floor(30 + Math.random() * 50),
        timestamp: new Date(time).toISOString(),
        duration: Math.floor(15 + Math.random() * 40),
      });
      time += Math.floor((15 + Math.random() * 40) * 60 * 1000);
    }
  });

  return history;
}

export const initialTravelHistory = [
  ...makeHistory('t1'),
  ...makeHistory('t2'),
  ...makeHistory('t3'),
];

// ── Geofences (demo seed) ───────────────────────────────────────────────────
// A geofence is a circular zone (center + radius in meters) assigned to a
// truck. If that truck's live position moves outside the radius, an alert
// fires (see AppContext.checkGeofenceViolations).
export const initialGeofences = [
  {
    id: 'gf1',
    name: 'Manila Delivery Zone',
    truckId: 't1',
    documentId: 'dr1',
    shape: 'circle',
    centerLat: 14.5995,
    centerLng: 120.9842,
    address: 'Roxas Blvd, Manila',
    radiusMeters: 3000,
    points: [],
    color: '#3b82f6',
    active: true,
    createdAt: '2024-06-03',
  },
];
